// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 485) return "static/chunks/485-c56dbb4233fd96fe.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","671":"b3e386a4"}[chunkId] || chunkId) + "." + {"146":"3ae8da1467aa02b1","298":"3c17f9a45cf5b456","340":"e8e8300ee372963d","367":"0d7d446e993d6eea","671":"52c67110d17b4775"}[chunkId] + ".js";
};